(() => {
  if (window.aathiPhoneLoginBound) return;
  window.aathiPhoneLoginBound = true;
  let busy = false;
  function showStatus(link, text) {
    let status = document.getElementById('aathi-account-login-status');
    if (!status) {
      status = document.createElement('p'); status.id = 'aathi-account-login-status'; status.setAttribute('role', 'status');
      status.style.cssText='position:fixed;top:90px;left:50%;transform:translateX(-50%);z-index:2147483646;background:#fffaf1;color:#173f35;padding:14px 20px;border:1px solid #d9dfd2;border-radius:8px;box-shadow:0 5px 20px #0002;max-width:90vw;font:14px system-ui';
      document.body.appendChild(status);
    }
    status.textContent = text;
    return status;
  }
  window.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin || !/^\/account(?:\/orders)?\/?$/.test(url.pathname)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    link.closest('details')?.removeAttribute('open');
    if (busy) return;
    busy = true; link.setAttribute('aria-busy', 'true');
    const started = Date.now();
    let status;
    function openLogin() {
      if (typeof window.kpHandleLogin === 'function') {
        try {
          window.kpHandleLogin('/account');
          status?.remove();
        } catch (error) {
          showStatus(link, 'Phone login could not open. Please refresh the page and try again.');
          console.warn('AathiLife phone login failed to open.');
        } finally { busy = false; link.removeAttribute('aria-busy'); }
        return;
      }
      if (Date.now() - started >= 12000) {
        showStatus(link, 'Phone login is temporarily unavailable. Please refresh the page and try again.');
        busy = false; link.removeAttribute('aria-busy'); return;
      }
      if (!status) status = showStatus(link, 'Opening phone login…');
      setTimeout(openLogin, 150);
    }
    openLogin();
  }, true);
})();
